import Jobseekers from '@/api/jobseekers'

export default {
  namespaced: true,
  state: {
    jobseekerProfile: null
  },
  getters: {
    resume (state) {
      return (state.jobseekerProfile && state.jobseekerProfile.resumeUrl)
        ? state.jobseekerProfile.resumeUrl : null
    },
    resumeStatus (state) {
      if (
        state.jobseekerProfile &&
        state.jobseekerProfile.resumeUrl &&
        state.jobseekerProfile.resumeUrl.length > 0
      ) {
        return 'Attached'
      } else {
        return 'Unattached'
      }
    },
    mundoCryptoCerUrl (state) {
      return (state.jobseekerProfile && state.jobseekerProfile.mundoCryptoCer)
        ? state.jobseekerProfile.mundoCryptoCer : ''
    },
    mundoCryptoCerStatus (state) {
      if (
        state.jobseekerProfile &&
        state.jobseekerProfile.mundoCryptoCer &&
        state.jobseekerProfile.mundoCryptoCer.length > 0
      ) {
        return true
      } else {
        return false
      }
    }
  },
  mutations: {
    setJobseekerProfile (state, profile) {
      state.jobseekerProfile = profile
    }
  },
  actions: {
    async getJobseekerProfile ({ commit }) {
      const profile = await Jobseekers.get()
      commit('setJobseekerProfile', profile)
    },
    async updateJobseekerProfile ({ commit }, data) {
      const profile = await Jobseekers.update(data)
      commit('setJobseekerProfile', profile)
    },
    async updateJobseekerProfileVisibility ({ commit }, data) {
      const profile = await Jobseekers.updateVisibility(data)
      commit('setJobseekerProfile', profile)
    },
    async uploadJobseekerResume ({ commit }, file) {
      const profile = await Jobseekers.uploadResume(file)
      commit('setJobseekerProfile', profile)
    },
    async uploadMundoCrypto ({commit}, file) {
      const profile = await Jobseekers.uploadMundoCrypto(file)
      commit('setJobseekerProfile', profile)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/jobseeker-profiles.js